import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Card, Markdown, Text } from "@wojo/ui";
import { useId } from "react";
import { useTourPageContext } from "../../_client/context";
import { TourSectionId } from "../../_client/hooks";
import styles from "./Flights.module.scss";

export const Flights: React.FC = () => {
    const { pageConfig } = useTourPageContext();
    const headingId = useId();
    const { productPage } = useI18n("productPage");

    return (
        <section
            aria-labelledby={headingId}
            className={styles.container}
            id={TourSectionId.FLIGHTS}
            tabIndex={-1}
        >
            <Text.Heading
                order="3"
                tag="h2"
                id={headingId}
                style={{ marginBottom: "var(--g-spacing-sm)" }}
            >
                {productPage.flights.heading.l()}
            </Text.Heading>
            {pageConfig.flightsDescription && (
                <Text.Body style={{ marginBottom: "var(--g-spacing-lg)" }}>
                    {pageConfig.flightsDescription}
                </Text.Body>
            )}
            {pageConfig.flightsInclusionsHeading &&
                pageConfig.flightsInclusions && (
                    <Card>
                        <Text.Heading
                            order="5"
                            tag="h3"
                            style={{ marginBottom: "var(--g-spacing-sm)" }}
                        >
                            {pageConfig.flightsInclusionsHeading}
                        </Text.Heading>
                        <Markdown
                            markdown={pageConfig.flightsInclusions}
                            className={styles.markdown}
                            onLinkClick={(_, a) => {
                                gtmSendEvent({
                                    event: "track",
                                    ga4_object: "LINK",
                                    ga4_action: "CLICKED",
                                    clickText: a.innerText,
                                });
                            }}
                        />
                    </Card>
                )}
        </section>
    );
};
